import { useIsMobile } from '@amzn/storm-ui'
import React from 'react'
import { WidgetTypes } from '../../common/constants'
import { useFeatureContext } from '../../contexts/FeatureContext'
import { taktId } from '../../utils/takt'
import { IngressLink, NoDataContainer, ReleaseNotesText, NoNewReleaseText } from './style'

export const FeatureModalNoData = () => {
  const { featureLabels } = useFeatureContext()
  return (
    <NoDataContainer>
      <NoNewReleaseText type="h3">{featureLabels?.fitNoDataTitle}</NoNewReleaseText>
      <ReleaseNotesText fontSize="small">
        {featureLabels?.fitNoDataContent}{' '}
        <IngressLink external={true} href="https://advertising.amazon.com/resources/whats-new" target="_blank" data-takt-id={taktId(WidgetTypes.WhatsNewCenterItem, 'annouce-link', useIsMobile())}>
          {featureLabels?.fitNoDataLinkLabel}
        </IngressLink>
        {'.'}
      </ReleaseNotesText>
    </NoDataContainer>
  )
}
